import { useContext } from "react";
import { DependenciesContext } from "../contexts/dependencies/context";
import type { CedeReactDependencies } from "../contexts/dependencies/dependencies";

export function useDependencies<T>() {
  return useContext<T & CedeReactDependencies>(
    DependenciesContext as unknown as React.Context<T & CedeReactDependencies>,
  );
}
